export default __webpack_public_path__ + "66055d92bf2ffdda935b3757ffe1812f.svg";